/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import * as yup from "yup";

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { format, parse } from "date-fns";

import AutoComplete from "@/components/hookForms/autoComplete";
import CloseIcon from "@mui/icons-material/Close";
import DatePickerMui from "@/components/hookForms/datePicker";
import IconButton from "@mui/material/IconButton";
import TextInput from "@/components/hookForms/textField";
import { Title } from "./styles";
import messages from "@/utils/messages";
import serviceUsuario from "@/services/serviceUsuario";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    onClose?: any;
    props?: any;
}
const Modal: React.FC<IDialogProps> = ({ open, onClose, props, onSuccess }) => {
    const [disableInputs, setDisabledInputs] = useState<boolean>(true);
    const [dataInicio, setDataInicio] = useState(null);
    const [isDisable, setDisable] = useState(false);

    const listPerfil = [
        { value: "Admin", label: "Admin" },
        { value: "Master", label: "Master" },
        { value: "OeM", label: "OeM" },
        { value: "Consulta", label: "Consulta" },
        { value: "Regular", label: "Regular" },
        { value: "ComercialPreVendas", label: "ComercialPreVendas" },
    ];

    const ativoList = [
        { value: "Sim", label: "Sim" },
        { value: "Não", label: "Não" },
    ];

    const validationSchema = yup.object().shape({
        email: yup.string().email().required(messages.requiredField),
        perfilTemporario: yup.string().nullable().notRequired(),
        dataInicioPerfilTemporario: yup.date().when("perfilTemporario", (perfilTemporario: string, schema: any) => {
            if (perfilTemporario && perfilTemporario.length > 0) {
                return schema.required(messages.requiredField).typeError(messages.requiredField);
            }

            return schema.nullable().optional();
        }),
        dataFimPerfilTemporario: yup
            .date()
            .nullable()
            .when(
                ["perfilTemporario", "dataInicioPerfilTemporario"],
                (perfilTemporario: string, dataInicioPerfilTemporario: string, schema: any) => {
                    if (perfilTemporario && perfilTemporario.length > 0) {
                        return schema.required(messages.requiredField).typeError(messages.requiredField);
                    }

                    return schema.nullable().optional();
                }
            )
            .test({
                name: "teste",
                message: "Data final não pode ser menor do que a data inicial",
                params: { dataInicio },
                test: (value: any): boolean => {
                    if (dataInicio) {
                        let inicio = parse(format(dataInicio, "dd/MM/yyyy"), "dd/MM/yyyy", new Date());
                        let fim = parse(format(value, "dd/MM/yyyy"), "dd/MM/yyyy", new Date());

                        return inicio <= fim;
                    }
                    return true;
                },
            }),
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            ativo: "",
            email: "",
            perfil: "",
            nome: "",
            perfilTemporario: "",
            dataInicioPerfilTemporario: null,
            dataFimPerfilTemporario: null,
        },
    });

    useEffect(() => {
        if (props) {
            if (props.perfilTemporario && props.perfilTemporario.length > 0) {
                setDisabledInputs(false);
            }
            reset(props);
        }
    }, [props]);

    const handleBlockInputs = (data: string) => {
        setDisabledInputs(true);
        if (data) {
            setDisabledInputs(false);
        }
    };

    const onSubmit = (values: any) => {
        setDisable(true);

        const inicio = new Date(values.dataInicioPerfilTemporario);
        const fim = new Date(values.dataFimPerfilTemporario);

        const newValues = {
            ...values,
            dataInicioPerfilTemporario: values.dataInicioPerfilTemporario ? inicio : null,
            dataFimPerfilTemporario: values.dataFimPerfilTemporario ? fim : null,
            ativo: values.ativo === "Sim" ? "S" : "N",
            email: values.email.toString().toLowerCase(),
        };

        serviceUsuario
            .update(newValues)
            .then((result) => {
                if (result) {
                    toast.success(messages.updateSucess);
                    reset();
                    onClose();
                    onSuccess();
                }
            })
            .catch((err) => {
                toast.error(messages.updateError, err);
            })
            .finally(() => {
                setDisable(false);
            });
    };

    const el = document.getElementsByClassName("MuiAutocomplete-clearIndicator")[2];
    if (el) {
        el.addEventListener("click", () => {
            reset({ dataInicioPerfilTemporario: null, dataFimPerfilTemporario: null });
        });
    }

    return (
        <Box>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    <Title>Editar</Title>
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose();
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent dividers>
                        <Typography variant="subtitle1">Nome: {props.nome}</Typography>

                        <Grid container spacing={1}>
                            <Grid item md={12} xs={12}>
                                <TextInput name="email" label="E-mail" control={control} error={errors} />
                            </Grid>

                            <Grid item md={12} xs={12}>
                                <AutoComplete
                                    options={listPerfil}
                                    name="perfil"
                                    label="Perfil Permanente"
                                    control={control}
                                    error={errors}
                                />
                            </Grid>

                            <Grid item md={12} xs={12}>
                                <AutoComplete
                                    options={ativoList}
                                    name="ativo"
                                    label="Ativo"
                                    control={control}
                                    error={errors}
                                />
                            </Grid>

                            <Grid item md={12} xs={12}>
                                <AutoComplete
                                    id="teste"
                                    onChange={(item: any) => handleBlockInputs(item)}
                                    options={listPerfil}
                                    name="perfilTemporario"
                                    label="Perfil Temporário"
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item md={6} xs={12}>
                                <DatePickerMui
                                    disabled={disableInputs}
                                    name="dataInicioPerfilTemporario"
                                    label="De"
                                    control={control}
                                    error={errors}
                                    onChange={(item) => setDataInicio(item)}
                                />
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <DatePickerMui
                                    disabled={disableInputs}
                                    name="dataFimPerfilTemporario"
                                    label="Até"
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button
                            onClick={() => {
                                onClose();
                                reset();
                            }}
                            color="warning"
                            variant="contained"
                            style={{ width: "159px", height: "44px" }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            type="submit"
                            color="primary"
                            variant="contained"
                            disabled={isDisable}
                            style={{ width: "159px", height: "44px" }}
                        >
                            Salvar
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </Box>
    );
};

export default Modal;
